import React from 'react'
import styles from '../FusionTechnology/FusionTechnology.module.css'

const FusionTechnology = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.uppersection}>
                    <div className={styles.FusionTechnoImg}>
                        <img src='Images/FusionTechno.webp' alt='man working in office benefitting from fusionTechnology™ and HA+TSP®' loading="lazy" decoding="async" />

                    </div>
                    <div className={styles.content}>
                        <h1 className={styles.title}>Comfort inside and out</h1>
                        <h3 className={styles.subTitle}>FusionTechnology™ Inside</h3>
                        <div className={styles.description}>
                            <p>Manufactured from vifilcon C hydrogel and enhanced with natural co-polymers, hyaluronic acid, and tamarind seed polysaccharide, Deseyne® is engineered to support sustained hydration, comfort, and visual stability throughout the day. As a daily disposable soft contact lens, it offers a safety profile associated with a lower risk of lens-related adverse events, with no adverse events reported in the clinical study.</p>
                        </div>


                    </div>
                </div>



            </div>
            <div className={styles.bootomSection}>
                <div className={styles.LacriMassSection}>
                    <div className={styles.lacriImg}>
                        <img src='Images/Lacrimax-Graphic.svg' alt='immustration of Lacrimass™ design supporting uniform tear distribution' loading="lazy" decoding="async" />
                    </div>
                    <div className={styles.contentDiv}>
                        <h1 className={styles.lacriTitle}>LacriMass™ outside</h1>
                        {/* <h3 className={styles.lacrisubTitle}>XXX</h3> */}
                        <div className={styles.lacriDescription}>
                            <p><b>LacriMass™ surface design</b> promotes a non-uniform tear film distribution across the lens surface, increasing tear film thickness in the peripheral zones and enhancing ocular surface protection where mechanical stress is highest.</p>

                        </div>
                    </div>
                    <div className={styles.shipImg}>
                        <img src='Images/shipImg.webp' alt=' Two kayakers enjoying active lifestyle' loading="lazy" decoding="async" />
                    </div>
                </div>
                <div className={styles.LeftCornerImg}>
                    <img src='Images/LeftCornerImg.webp' alt='LeftCornerImg' loading="lazy" decoding="async" />

                </div>
            </div>


        </div>
    )
}

export default FusionTechnology
